import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/queryKeys";
import { borrowerService } from "@/services/borrowers";

export function useAddBorrowerNoteMutation(borrowerId: number | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (text: string) => {
      if (borrowerId == null) throw new Error("No borrower ID");
      return borrowerService.addNote(borrowerId, text);
    },
    onSuccess: () => {
      if (borrowerId != null)
        void queryClient.invalidateQueries({ queryKey: queryKeys.borrower(borrowerId) });
    },
  });
}

export function useRemoveBorrowerNoteMutation(borrowerId: number | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (noteId: string) => {
      if (borrowerId == null) throw new Error("No borrower ID");
      return borrowerService.removeNote(borrowerId, noteId);
    },
    onSuccess: () => {
      if (borrowerId != null)
        void queryClient.invalidateQueries({ queryKey: queryKeys.borrower(borrowerId) });
    },
  });
}
